import Icon from "@ant-design/icons";
import { Col, Collapse, Row, Typography } from "antd";
import { FormattedMessage } from "react-intl";

import { useMediaXs } from "../../../lib/hooks/basic/media";
import { CommentList, type CommentListProps } from "../CommentList";

export function CommentSection(props: CommentListProps) {
  const isXs = useMediaXs();
  return (
    <Collapse
      bordered={false}
      expandIconPlacement="end"
      style={{ background: "none" }}
      defaultActiveKey={["comments"]}
      items={[
        {
          className: "wizard-section",
          key: "comments",
          label: (
            <Row gutter={16} align="middle">
              <Col>
                <Icon
                  component={() => (
                    <img src="/images/icons/comment.svg" alt="" />
                  )}
                />
              </Col>
              <Col flex={1}>
                <Typography.Title level={3} className="mb-0">
                  <FormattedMessage id="comments" defaultMessage="comments" />
                </Typography.Title>
                {!isXs && (
                  <Typography.Text type="secondary">
                    <FormattedMessage
                      id="workOrders.comments.hint"
                      defaultMessage="comments"
                    />
                  </Typography.Text>
                )}
              </Col>
            </Row>
          ),
          children: <CommentList {...props} />,
        },
      ]}
    />
  );
}
